<template>
  <div v-if="userDiv === 0">
    <SuperAdmin/>
  </div>
  <div v-else-if="userDiv === 1">
    <Admin/>
  </div>
  <div v-else-if="userDiv === 2">
    <User/>
  </div>
</template>

<script>
import SuperAdmin from '@/components/partials/sub_headers/SuperAdmin'
import Admin from '@/components/partials/sub_headers/Admin'
import User from '@/components/partials/sub_headers/User'

export default {
  name: 'sub-header',
  props: {
    userDiv: null
  },
  components: {
    SuperAdmin,
    Admin,
    User
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/SubHeader.vue